export default {
	token: 'c0432106f946b4400e5148e32fcec62f1b9e6088',
}
